import React, { useState, useRef } from 'react';
import {
    GoogleMap,
    Marker,
    InfoWindow,
    DirectionsRenderer
} from '@react-google-maps/api';
import './FollowingMap.scss';
import { colors } from '@material-ui/core';


export const FollowingMap = (props) => {
    const { data, showInfoWindow, directionsResponse, directionsResponse2 } = props;

    const [viewport, setViewport] = useState(null);
    const mapRef = useRef(null);

    const handleDirectionsChanged = () => {
        if (mapRef.current) {
            // Calculate bounds for the new route
            // eslint-disable-next-line no-undef
            const bounds = new google.maps.LatLngBounds();
            if (directionsResponse && directionsResponse.routes && directionsResponse.routes.length > 0) {
                const route = directionsResponse.routes[0];
                route.legs.forEach((leg) => {
                    bounds.extend(leg.start_location);
                    bounds.extend(leg.end_location);
                });
            }

            // Fit the map to the new bounds
            // mapRef.current.fitBounds(bounds);

            // // Store the current viewport for future comparisons
            // setViewport({
            //     center: mapRef.current.getCenter(),
            //     zoom: mapRef.current.getZoom(),
            // });
        }
    };

    if (data?.length > 0) {
        return (
            <>
                <div className='map-container'>
                    <GoogleMap
                        ref={mapRef}
                        // center={middlePoint}
                        // center={data[0]}
                        zoom={18}
                        mapContainerStyle={{ width: '100%', height: '100%' }}
                        options={{
                            zoomControl: true,
                            streetViewControl: false,
                            mapTypeControl: false,
                            fullscreenControl: true,
                        }}
                    ><>
                            {data?.map((d, i) => (
                                <Marker
                                    onClick={() => showInfoWindow(i)}
                                    position={{ lat: d?.lat, lng: d?.lng }}
                                    // label={i}
                                    icon={d?.icon}
                                >
                                    {d?.show && d?.name &&
                                        <InfoWindow>
                                            <div className='custom-info-window'>
                                                <p>{d?.name} </p>
                                            </div>
                                        </InfoWindow>
                                    }
                                </Marker>
                            ))
                            }
                        </>
                        {directionsResponse && (
                            <DirectionsRenderer
                                directions={directionsResponse}
                                options={{
                                    suppressMarkers: true,
                                    preserveViewport: { zoom: 18 }, // Only preserve viewport after initial load
                                    polylineOptions: {
                                        strokeColor: '#f27730',
                                        strokeWeight: 5,
                                    },
                                }}
                            // onDirectionsChanged={handleDirectionsChanged}

                            // draggable={true}
                            // suppressMarkers={true}
                            // markerOptions={{ icon: data[0]?.icon }}
                            />
                        )}

                        {directionsResponse2 && (
                            <DirectionsRenderer
                                directions={directionsResponse2}
                                options={{
                                    suppressMarkers: true,
                                    preserveViewport: { zoom: 18 }, // Only preserve viewport after initial load
                                    polylineOptions: {
                                        strokeColor: 'black',
                                        strokeWeight: 5,
                                    },

                                }}
                            />
                        )}
                    </GoogleMap>
                </div>
            </>
        )
    } else {
        return null
    }
}
